module.exports = __webpack_public_path__ + "img/sibi_4kl.0287515c.jpg";